<template>
	<article>
		<div v-if="article">
			<div style="position: relative">
				<h1 v-if="article.heading" class="pt-5 pl-5">{{ article.heading }}</h1>

				<html-description class="p-5 article-description" ref="description" :html="article.body" @html-loaded="triggerInjects"/>

				<product-browser
					v-show="showBrowser"
					ref="browser"
					:layoutOptions="{ compactLayout: true, compactThreshold: 999999999 }"
					:article="article"
					:url="'article/' + article.id"
					:totalProductCount.sync="totalProductCount"
					:resetData="resetData"
					@loaded="onPageLoad"
				/>

				<div style="overflow-anchor: none">
					<html-description class="p-5 article-description" ref="description" :html="article.secondBody" />
				</div>

				<div class="clearfix" />
			</div>
		</div>
	</article>
</template>

<script>
import Vue from "vue";
import waja from 'waja';
import router from 'router';
import store from 'datastore';
import metaHandler from 'metaHandler';
import { error, urlFormat } from 'utils';
import topListSlider from '../top-list-slider.vue';
import author from '../author.vue';

export default {
	beforeRouteEnter (to, frm, next) {
		waja.get('article/' + to.params.id)
			.on('success', res => {
				next(vm => {
					vm.article = res.data;
				});
			})
			.on('404', res => {
				res.text().then(text => {
					next(error(404, 'Artikeln kunde inte hittas', {}));
				});
			})
			.on('error', () => {
				next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
			}).go();
	},
	beforeRouteUpdate (to, frm, next) {
		waja.get('article/' + to.params.id)
			.on('success', res => {
				next(vm => {
					vm.article = res.data;
				});
			})
			.on('404', res => {
				res.text().then(text => {
					next(error(404, 'Artikeln kunde inte hittas', {}));
				});
			})
			.on('error', () => {
				next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
			}).go();
	},
	data () {
		return {
			article: null,
			totalProductCount: 0,
			resetData: [],
		};
	},
	computed: {
		showBrowser () {
			return this.article.id && this.totalProductCount > 0;
		},
	},
	methods: {
		onPageLoad () {
			store.dispatch('prerender/pageLoaded');
		},
		triggerInjects () {
			this.injectToplist();
			this.injectAuthor();
		},
		injectToplist () {
			const toplistTag = document.querySelectorAll('.topList');
			if (toplistTag.length > 0) {
				for (let i = 0; i < toplistTag.length; i++) {
					const toplistId = Number(toplistTag[i].innerHTML);
					const componentInstance = new Vue( Object.assign({}, topListSlider, {
						store: store,
						router: router,
						propsData: { id: toplistId, singleToplist: true, showDescription: false },
					}));
					componentInstance.$mount('#topListMountpoint-' + toplistId);
				}
			}
		},
		injectAuthor () {
			const authorTag = document.getElementById('author');
			if (authorTag) {
				const authorId = authorTag.innerHTML;
				const componentInstance = new Vue(Object.assign({}, author, {propsData: { authorId : authorId}}));
				componentInstance.$mount('#author');
			}
		},
	},
	watch: {
		article (article) {
			router.updateParams({
				id: article.id,
				name: urlFormat(article.heading),
			});

			if (article.id) {
				this.resetData = [
					[{
						type: 'article',
						value: article.id,
						label: article.heading,
						hidden: true,
						persistOnClear: true,
					}],
					true,
				];
			} else {
				Vue.nextTick(() => {
					this.onPageLoad();
				});
			}

			const metaDescription = article.metaDescription || 'Kolla in ' + article.heading +
				' på Webhallen.com. Fri frakt för medlemmar ✓ Öppet köp 30' +
				' dagar ✓ Snabba leveranser - Köp online eller i butik!';

			metaHandler.set('description', metaDescription);
		},
	},
};
</script>
